"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardWidgetExecution = void 0;
// (C) 2020-2022 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var useDashboard_1 = require("./useDashboard");
var internal_1 = require("./internal");
var utils_1 = require("./utils");
/**
 * Hook allowing to get execution for particular dashboard widget.
 * @param config - configuration of the hook
 * @beta
 * @deprecated Will be removed in the 8.10.0 release. Superseded by Dashboard component; please see `@gooddata/sdk-ui-dashboard` and GoodData.UI documentation for v8.7
 */
function useDashboardWidgetExecution(_a) {
    var _b;
    var dashboard = _a.dashboard, widgetRef = _a.widget, filters = _a.filters, backend = _a.backend, workspace = _a.workspace;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useDashboardWidgetExecution");
    utils_1.workspaceInvariant(effectiveWorkspace, "useDashboardWidgetExecution");
    var _c = useDashboard_1.useDashboard({
        dashboard: dashboard,
        backend: effectiveBackend,
        workspace: effectiveWorkspace,
    }), dashboardResult = _c.result, dashboardStatus = _c.status, dashboardError = _c.error;
    var _d = internal_1.useDashboardLayoutData({
        dashboardLayout: dashboardResult === null || dashboardResult === void 0 ? void 0 : dashboardResult.layout,
        backend: effectiveBackend,
        workspace: effectiveWorkspace,
    }), dashboardLayoutResult = _d.result, dashboardLayoutStatus = _d.status, dashboardLayoutError = _d.error;
    var widget = (dashboardResult === null || dashboardResult === void 0 ? void 0 : dashboardResult.layout) &&
        sdk_backend_spi_1.layoutWidgets(dashboardResult.layout)
            .filter(sdk_backend_spi_1.isWidget)
            .find(function (w) {
            return sdk_model_1.areObjRefsEqual(widgetRef, {
                uri: sdk_backend_spi_1.widgetUri(w),
                identifier: sdk_backend_spi_1.widgetId(w),
            });
        });
    if ((dashboardResult === null || dashboardResult === void 0 ? void 0 : dashboardResult.layout) && !widget) {
        throw new sdk_ui_1.UnexpectedSdkError("Widget with ObjRef " + sdk_model_1.objRefToString(widget) + " not found on the referenced dashboard.");
    }
    var kpiWidget = (widget === null || widget === void 0 ? void 0 : widget.type) === "kpi" ? widget : undefined;
    var insightWidget = (widget === null || widget === void 0 ? void 0 : widget.type) === "insight" ? widget : undefined;
    var kpiExecution = internal_1.useDashboardKpiExecution({
        kpiWidget: kpiWidget,
        filterContext: dashboardResult === null || dashboardResult === void 0 ? void 0 : dashboardResult.filterContext,
        filters: filters,
        backend: effectiveBackend,
        workspace: effectiveWorkspace,
    });
    var insightExecution = internal_1.useDashboardInsightExecution({
        insightWidget: insightWidget,
        insight: dashboardLayoutResult === null || dashboardLayoutResult === void 0 ? void 0 : dashboardLayoutResult.getInsightByRef(insightWidget === null || insightWidget === void 0 ? void 0 : insightWidget.insight),
        filters: filters,
        filterContext: dashboardResult === null || dashboardResult === void 0 ? void 0 : dashboardResult.filterContext,
        backend: effectiveBackend,
        workspace: effectiveWorkspace,
    });
    var _e = (widget === null || widget === void 0 ? void 0 : widget.type) === "kpi" ? kpiExecution : insightExecution, executionResult = _e.result, executionStatus = _e.status, executionError = _e.error;
    var statuses = [dashboardStatus, dashboardLayoutStatus, executionStatus];
    var error = (_b = dashboardError !== null && dashboardError !== void 0 ? dashboardError : dashboardLayoutError) !== null && _b !== void 0 ? _b : executionError;
    if (error) {
        return {
            error: error,
            result: undefined,
            status: "error",
        };
    }
    else if (statuses.some(function (s) { return s === "loading"; })) {
        return {
            error: undefined,
            result: undefined,
            status: "loading",
        };
    }
    return {
        error: undefined,
        result: executionResult,
        status: "success",
    };
}
exports.useDashboardWidgetExecution = useDashboardWidgetExecution;
//# sourceMappingURL=useDashboardWidgetExecution.js.map